import React from 'react';

function Label(props) {
  return(
    <label className="label">{props.text}</label>
  )
}

export default Label;
